import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IntervenantSelectedService {
  private intervenantSelected: any;

  // Save the Intervenant element
  setIntervenantSelected(intervenant: any): void {
    this.intervenantSelected = intervenant;
  }

  // Retrieve the Intervenant element
  getIntervenantSelected(): any {
    return this.intervenantSelected;
  }

  hasIntervenantSelected(): boolean {
    return !!this.intervenantSelected;
  }
}
